export default "__VITE_ASSET__05c3bdad__"